import { FEATURES } from "@/config/features";
import { PLAN_START } from "@/config/plans";

/**
 * [sc-48351] Piano, funzioni accese e tetti dell'azienda collegata.
 *
 * Li calcola l'API e arrivano col profilo (`/company-profile`): il web non
 * rifà il conto, lo legge. `config/features.js` resta come valore di ripiego,
 * ed è START: finché il profilo non è arrivato, o se arriva storto, non si
 * accende niente di PLUS.
 */
export const PIANO_START = Object.freeze({
  plan: PLAN_START.name,
  features: FEATURES,
  limits: Object.freeze({
    maxOperators: PLAN_START.maxOperators,
    maxItems: PLAN_START.maxItems,
  }),
});

/** Un tetto come lo manda l'API: numero, oppure `null` = senza tetto. */
function tetto(valore, ripiego) {
  if (valore === null) return null;
  return Number.isInteger(valore) && valore > 0 ? valore : ripiego;
}

/**
 * Legge piano, funzioni e tetti dalla risposta del profilo.
 *
 * Solo i nomi che il web conosce, e accesi solo se l'API dice `true`: un
 * campo mancante o scritto male vale spento.
 *
 * @param {{plan?: string, features?: object, limits?: object}|null} data
 */
export function leggiPiano(data) {
  if (!data || typeof data.features !== "object" || data.features === null) {
    return PIANO_START;
  }

  const features = {};
  for (const name of Object.keys(FEATURES)) {
    features[name] = data.features[name] === true;
  }

  return Object.freeze({
    plan: data.plan === "PLUS" ? "PLUS" : PLAN_START.name,
    features: Object.freeze(features),
    limits: Object.freeze({
      maxOperators: tetto(data.limits?.maxOperators, PLAN_START.maxOperators),
      maxItems: tetto(data.limits?.maxItems, PLAN_START.maxItems),
    }),
  });
}
